var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * NumberEightFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNumberEightFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23 12C23 14.9174 21.8411 17.7153 19.7782 19.7782C17.7153 21.8411 14.9174 23 12 23C9.08262 23 6.28473 21.8411 4.22183 19.7782C2.15893 17.7153 1 14.9174 1 12C1 9.08262 2.15893 6.28473 4.22183 4.22183C6.28473 2.15893 9.08262 1 12 1C14.9174 1 17.7153 2.15893 19.7782 4.22183C21.8411 6.28473 23 9.08262 23 12ZM12.5893 10.625C12.9019 10.625 13.2016 10.5008 13.4227 10.2798C13.6437 10.0588 13.7679 9.759 13.7679 9.44643C13.7679 9.13385 13.6437 8.83408 13.4227 8.61305C13.2016 8.39203 12.9019 8.26786 12.5893 8.26786H11.4107C11.0981 8.26786 10.7984 8.39203 10.5773 8.61305C10.3563 8.83408 10.2321 9.13385 10.2321 9.44643C10.2321 9.759 10.3563 10.0588 10.5773 10.2798C10.7984 10.5008 11.0981 10.625 11.4107 10.625H12.5893ZM8.26786 9.44643C8.26786 8.61289 8.59898 7.81349 9.18838 7.22409C9.77778 6.63469 10.5772 6.30357 11.4107 6.30357H12.5893C13.1873 6.30339 13.773 6.47386 14.2776 6.79496C14.7822 7.11606 15.1846 7.57445 15.4377 8.11632C15.6908 8.65818 15.7841 9.26101 15.7065 9.85402C15.629 10.447 15.3838 11.0056 14.9999 11.4641C15.6897 12.077 16.125 12.9696 16.125 13.9643V14.3571C16.125 15.2428 15.7732 16.0921 15.1469 16.7184C14.5207 17.3446 13.6713 17.6964 12.7857 17.6964H11.2143C10.3287 17.6964 9.47929 17.3446 8.85305 16.7184C8.22682 16.0921 7.875 15.2428 7.875 14.3571V13.9643C7.875 12.9696 8.31029 12.0754 9.00014 11.4641C8.52587 10.8989 8.26652 10.1843 8.26786 9.44643ZM12.7857 15.7321H11.2143C10.8496 15.7321 10.4999 15.5873 10.242 15.3294C9.98415 15.0716 9.83929 14.7218 9.83929 14.3571V13.9643C9.83929 13.2053 10.4553 12.5893 11.2143 12.5893H12.7857C13.5447 12.5893 14.1607 13.2053 14.1607 13.9643V14.3571C14.1607 14.7218 14.0158 15.0716 13.758 15.3294C13.5001 15.5873 13.1504 15.7321 12.7857 15.7321Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconNumberEightFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberEightFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberEightFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-number-eight-filled') === undefined) {
    customElements.define('cat-icon-number-eight-filled', BlocksIconNumberEightFilled);
}
